import { Skeleton } from '@mui/material'
import { MasterDetail } from 'components/core-v2'

import classes from './loading.module.scss'

const Item = () => (
  <div className={classes.item}>
    <Skeleton className="mb-1" height="17px" width="200px" />
    <Skeleton height="17px" width="100px" />
  </div>
)

const Master = () => (
  <>
    <Skeleton classes={{ root: 'my-6' }} height="24px" width="180px" />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
    <Item />
  </>
)

export const Loading = () => <MasterDetail detailChildren={null} masterChildren={<Master />} />
